var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlurk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3C3C"
    },
    d: "M170.473,512c-64.178,0-116.39-52.212-116.39-116.39V196.288C54.083,88.054,142.136,0,250.37,0 h11.259c108.234,0,196.289,88.054,196.289,196.288c0,99.322-74.046,182.228-171.055,194.674v4.648 C286.863,459.788,234.651,512,170.473,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA0806"
    },
    d: "M261.629,0H256v474.462c19.147-20.752,30.863-48.457,30.863-78.852v-4.648 c97.009-12.446,171.055-95.352,171.055-194.674C457.917,88.054,369.863,0,261.629,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.629,59.849h-11.259c-75.232,0-136.44,61.209-136.44,136.44v199.318 c0,31.182,25.362,56.544,56.544,56.544c31.172,0,56.534-25.362,56.534-56.544V332.73h34.62c75.232,0,136.44-61.209,136.44-136.44 S336.861,59.849,261.629,59.849z M261.629,249.798h-49.699c-8.323,0-15.079-6.745-15.079-15.079v-38.43 c0-29.514,24.005-53.519,53.519-53.519h11.259c29.514,0,53.519,24.005,53.519,53.519 C315.148,225.793,291.143,249.798,261.629,249.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE1EB"
    },
    d: "M261.629,59.849H256v82.922h5.629c29.514,0,53.519,24.005,53.519,53.519 c0,29.504-24.005,53.509-53.519,53.509H256v82.932h5.629c75.232,0,136.44-61.209,136.44-136.44S336.861,59.849,261.629,59.849z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlurk);
export default __webpack_public_path__ + "static/media/plurk.125b813b389af9e435e780b47fe7bfb4.svg";
export { ForwardRef as ReactComponent };